module.exports = __webpack_public_path__ + "img/07-cnbm-win.23370dde.png";